import axios from 'axios';
import { httpClient } from 'src/libs';
import authToken from 'src/services/auth-header';

// Public endpoints (no authentication required)
const getAllPlans = async () => {
  // Use the public endpoint for plans (no authentication required)
  const url = `${process.env.REACT_APP_API_V3_URL}/public/subscription_plans`;
  console.log('Fetching plans from URL:', url);
  console.log('Environment variables:', {
    REACT_APP_API_V3_URL: process.env.REACT_APP_API_V3_URL,
    REACT_APP_API_URL: process.env.REACT_APP_API_URL,
  });

  // Create a new axios instance for this specific request to avoid baseURL conflicts
  const response = await axios.get(url, {
    headers: {
      'Content-Type': 'application/json',
    },
  });
  console.log('Response status:', response.status);
  console.log('Response data:', response.data);
  return response.data;
};

// Private endpoints (authentication required)
const getCurrentSubscriptionStatus = async () => {
  const url = `${process.env.REACT_APP_API_V3_URL}/private/subscriptions/status`;
  const response = await axios.get(url, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${authToken()}`,
    },
  });
  return response.data;
};

const getAvailablePlansForUser = async () => {
  const url = `${process.env.REACT_APP_API_V3_URL}/private/subscription/plans`;
  const response = await axios.get(url, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${authToken()}`,
    },
  });
  return response.data;
};

const getCurrentUsage = async () => {
  const url = `${process.env.REACT_APP_API_V3_URL}/private/usage`;
  const response = await axios.get(url, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${authToken()}`,
    },
  });
  return response.data;
};

const subscribeToPlan = async (planId: number) => {
  const url = `${process.env.REACT_APP_API_V3_URL}/private/subscriptions`;
  const response = await axios.post(
    url,
    {
      plan_id: planId,
      success_url: `${window.location.origin}/channels`,
      cancel_url: `${window.location.origin}/choose-your-plan`,
    },
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${authToken()}`,
      },
    }
  );
  return response.data;
};

const upgradeToPlan = async (planId: number) => {
  const url = `${process.env.REACT_APP_API_V3_URL}/private/subscription_upgrades/upgrade`;
  const response = await axios.post(
    url,
    {
      plan_id: planId,
    },
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${authToken()}`,
      },
    }
  );
  return response.data;
};

const cancelSubscription = async () => {
  const url = `${process.env.REACT_APP_API_V3_URL}/private/subscription_upgrades/cancel`;
  const response = await axios.post(
    url,
    {},
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${authToken()}`,
      },
    }
  );
  return response.data;
};

const PlansAndBillingService = {
  // Public methods
  getAllPlans,

  // Private methods (authenticated users)
  getCurrentSubscriptionStatus,
  getAvailablePlansForUser,
  getCurrentUsage,
  subscribeToPlan,
  upgradeToPlan,
  cancelSubscription,
};

export default PlansAndBillingService;
